const createCdnURL = (size, url) => {
  const name_parts = url.split("/").pop().split(".");
  return `https://cdn.electroniks.pk/images/${name_parts[0]}/${size}.${name_parts[1]}`;
};

const appURL = "https://www.electroniks.pk";
const logoURL =
  "https://storage.googleapis.com/stateless-www-electroniks-pk/2021/02/7cf9930e-logon.637a7ff9.png";

function currencyFormat(num) {
  return "Rs. " + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

const sortByOrder = (arr) => {
  return arr.sort(function (a, b) {
    return parseInt(a.order) - parseInt(b.order);
  });
};

export { createCdnURL, appURL, logoURL, currencyFormat, sortByOrder };
